<template>
    <div>
        <div id="game-wrapper">
            <div id="game-content">
                <div id="game-container">
                    <div id="game-inner-container">

                        <div id="top-bar">
                            <div class="title d-sm-block">
                                <a>
                                    <h1 class="d-none d-sm-block">{{state.title}}</h1>
                                    <h1 class="d-block d-sm-none padding-right pl-0">ACG</h1>
                                </a>
                            </div>
                            <!--
                            <a class="btn btn-sm btn-danger ml-2" href="javascript:void(0);" @click="start" v-if="state.user_class == 'ADMIN'">
                                Channel Start
                            </a>
                            <a class="btn btn-sm btn-danger ml-2" href="javascript:void(0);" @click="shutdown" v-if="state.user_class == 'ADMIN'">
                                Channel Shutdown
                            </a>
                            <a class="btn btn-sm btn-primary ml-2" href="javascript:void(0);" @click="processExit" v-if="state.user_class == 'ADMIN'">
                                Process Exit
                            </a>
                            -->
                            <a class="btn btn-sm btn-danger ml-2" href="javascript:void(0);" @click="forceGameCrash" v-if="state.user_class == 'ADMIN' && state.game_state == 'IN_PROGRESS'">
                                Game Crash
                            </a>
                            <div class="title" id="hash-checker" v-if="state.display_hash_checker">
                                <a class="btn btn-sm btn-success d-none d-md-block ml-2" href="/hash" target="_blank">
                                    {{$trans('label.Hash')}}
                                </a>
                                <a class="btn btn-sm btn-success d-block d-md-none ml-2"  href="/hash" target="_blank">
                                    <i class="fa fa-link fa-align-center" aria-hidden="true"></i>
                                </a>
                            </div>
                            <div class="toggle-flag noselect" v-on:click="toggleDisplayFlags()">
                                <span :class="`flag-icon flag-icon-${this.lang}`" :alt="this.language_name" :title="this.language_name"></span>
                                <div class="flags-container" v-if="this.is_open_flags">
                                    <ul class="flags-row">
                                        <li v-for="list in state.languages" @click="changeLanguage(list.code, list.language)" :title="list.language">
                                            <i :class="`flag-icon flag-icon-${list.code.split('_')[1].toLowerCase()}`" :alt="list.language"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="user-login">
                                <div class="balance-bits" v-if="state.currency">
                                    <span>{{state.currency.toLowerCase()}}</span>: <span>{{utils.comma(state.balance)}}</span>
                                </div>
                                <div class="username d-none d-md-inline-block">
                                    <a href="javascript:void(0)" @click="doOpenUser(state.user_id)">
                                        <span class="username">{{state.username}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- top-bar //-->

                        <div id="game-playable-container">

                            <div id="game-left-container" :class="{'small-window': this.state.is_small}">

                                <div id="chart-controls-row">
                                    <div id="chart-controls-col">
                                        <div class="cell-wrapper">
                                            <div id="chart-controls-inner-container">
                                                <graphic-display ref="GraphicDisplay" v-bind:state="state"></graphic-display>
                                                <text-display ref="TextDisplay" v-bind:state="state"></text-display>
                                                <controls-container ref="ControlsContainer" v-bind:state="state"></controls-container>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- chart //-->

                                <div id="tabs-controls-row">
                                    <div id="tabs-controls-col">
                                        <div class="cell-wrapper">
                                            <tabs-selector ref="TabsSelector" v-bind:state="state"></tabs-selector>
                                        </div>
                                    </div>
                                </div><!-- tabs //-->

                            </div><!-- game-left-container //-->

                            <div id="game-right-container" v-if="!this.state.is_small">
                                <player-container ref="PlayerContainer" v-bind:state="state"></player-container>
                                <div v-if="state.display_play_info">
                                    <table class="game-play-info">
                                        <tbody>
                                        <tr>
                                            <td v-if="utils.inArray(['ADMIN', 'MODERATOR'], state.user_class)">Online: {{utils.comma(this.state.game_play_info.online)}}</td>
                                            <td>Playing: {{utils.comma(this.state.game_play_info.playing_count)}}</td>
                                            <td>Betting: {{utils.comma(this.state.game_play_info.betting_amount)}} {{String(this.state.currency).toLowerCase()}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div><!-- game-right-container //-->

                        </div><!-- game-playable-container //-->

                    </div>

                </div><!-- game-container //-->

            </div>
        </div>
        <div id="modals">
            <modal-user-stats v-bind:state="state" v-if="state.modals.user_stats.display"></modal-user-stats>
            <modal-game-information v-bind:state="state" v-if="state.modals.game_information.display"></modal-game-information>
        </div>
    </div>
</template>

<script>
    const GraphicDisplay = require('./graphic-display.vue').default;
    const TextDisplay = require('./text-display.vue').default;
    const ControlsContainer = require('./controls-container.vue').default;
    const TabsSelector = require('./tabs-selector.vue').default;
    const PlayerContainer = require('./player-container.vue').default;

    export default {
        name: "game-wrapper",
        components: {
            'graphic-display': GraphicDisplay,
            'text-display': TextDisplay,
            'controls-container': ControlsContainer,
            'tabs-selector': TabsSelector,
            'player-container': PlayerContainer,
            'modal-user-stats': require('./modal-user-stats.vue').default,
            'modal-game-information': require('./modal-game-information.vue').default,
        },
        props: ['state'],
        data: function()
        {
            return {
                utils: utils,
                fullscreen: false,
                theme: utils.cookie.get('_theme') || 'black',
                is_open_flags: false,
                lang: null,
                language: this.state.language,
                language_name: this.state.language_name,
            };
        },
        created()
        {
            // console.log('game-wrapper created');
            EventBus.$on('connected', this.onChange);
        },
        beforeDestroy()
        {
            EventBus.$off('connected', this.onChange);
        },
        mounted()
        {
            let self = this;
            // console.log('game-wrapper mounted.');
            EventBus.$emit('push_component', 'graphic-wrapper');

            if (this.state.graph_mode === 'text') {
                // TODO: Text mode
            }

            this.loadTheme();

            $('body').off('click').on('click', function(e) {
                if (!($(e.target).closest('.toggle-flag').length > 0)) {
                    self.is_open_flags = false;
                }
            });
        },
        beforeUpdate()
        {

        },
        updated()
        {
            // console.log('game-wrapper updated.');
        },
        methods: {
            onChange()
            {
                this.language = this.state.language;
                this.language_name = _.find(this.state.languages, {code: this.language}).language;

                this.setLanguage(this.language, this.language_name);
            },
            doOpenUser(user_id)
            {
                this.state.modals.user_stats.display = true;
                this.state.modals.user_stats.data.user_id = user_id;
            },
            switchFullScreen()
            {
                if (this.fullscreen) {
                    this.fullscreen = false;
                    this.exitFullscreen();
                } else {
                    this.fullscreen = true;
                    this.launchIntoFullscreen(window.document.documentElement);
                }
            },
            launchIntoFullscreen(element)
            {
                if(element.requestFullscreen) {
                    element.requestFullscreen();
                } else if(element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if(element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen();
                } else if(element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            },
            exitFullscreen()
            {
                if(document.exitFullscreen) {
                    document.exitFullscreen();
                } else if(document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if(document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            },
            changeTheme()
            {
                this.theme = (this.theme == 'white') ? 'black' : 'white';
                this.loadTheme();
                utils.cookie.set('_theme', this.theme, 365);
            },
            loadTheme()
            {
                if (this.theme == 'black') {
                    if ($('#theme-black').length == 0) {
                        utils.loadCss('/bustabit/css/blackTheme.css', 'theme-black');
                    }
                    $('body').addClass('black');
                } else {
                    $('#theme-black').remove();
                    $('body').removeClass('black');
                }
            },
            getThemeName()
            {
                let theme_name = (this.theme == 'white') ? 'black' : 'white';
                return theme_name.charAt(0).toUpperCase() + theme_name.slice(1) +' '+ 'Theme';
            },
            toggleDisplayFlags()
            {
                this.is_open_flags = !this.is_open_flags;
            },
            setLanguage(language, language_name)
            {
                let self = this;
                this.language = language;
                this.language_name = language_name;
                this.lang = this.language.split('_')[1].toLowerCase();

                try {
                    localStorage['language'] = self.language;
                    localStorage['language_name'] = self.language_name;
                    // $("html").attr("lang", this.lang);
                    // $('meta[http-equiv=Content-Language]').attr('content', this.language)
                } catch (e) {}
            },
            changeLanguage(language, language_name)
            {
                this.setLanguage(language, language_name);
                this.$store.dispatch('LANGUAGE', language);
            },
            start()
            {
                // console.log('start', this.state.channel, this.state.currency)
                this.state.socket.ws.emit('game_server_add_channel', {
                    game_server: 'GS01',
                    channel: this.state.channel
                })
            },
            shutdown()
            {
                // console.log('shutdown')
                this.state.socket.ws.emit('game_server_channel_shutdown', {
                    channel: this.state.channel
                })
            },
            processExit()
            {
                // console.log('process_exit')
                this.state.socket.ws.emit('process_exit')
            },
            forceGameCrash()
            {
                // console.log('game_server_channel_force_end_game');
                this.state.socket.ws.emit('game_server_channel_force_end_game', {
                    channel: this.state.channel
                })
            },
        },
    }
</script>

<style scoped>

</style>
